export const isDev = import.meta.env.VITE_BASE_API_URL?.includes("dev.api")

// Gate the per-segment version-diff highlight UX. Backend uses index-based
// segment alignment, which produces a "wall of red" when paragraphs are
// inserted/deleted between revisions. Stay disabled by default until the
// alignment upgrade ships server-side. The version-history listing and
// re-upload features can ship without this flag.
export const isVersionDiffHighlightEnabled =
  import.meta.env.VITE_ENABLE_VERSION_DIFF === "true"
